export default __webpack_public_path__ + "static/media/arrow-down.acd7a654.svg";